export default __webpack_public_path__ + "static/media/vehicle.19bc92ce.svg";